let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aEoU0")).then(() => parcelRequire('3rara'));